/* === Custom feature: per-product max quantity (custom.max_quantity metafield) ===
 *
 * Caps the product-page quantity selector by what is already in the cart, so a
 * customer cannot exceed the product's max across multiple adds. The Liquid side
 * renders max/data-max-quantity on the quantity input (snippets/product-info.liquid)
 * and caps cart line inputs (snippets/line-item.liquid); the theme's quantity-input
 * element enforces the max attribute on typing/steppers.
 *
 * UX layer only — hard enforcement is the cart validation function.
 */
(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function getCart() {
    try {
      const response = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      return response.ok ? await response.json() : null;
    } catch (error) {
      return null;
    }
  }

  function ensureNote(input) {
    const wrapper = input.closest('.product-info__quantity-selector') || input.parentElement;
    let note = wrapper.querySelector('.max-quantity-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'max-quantity-note text-sm text-subdued';
      wrapper.appendChild(note);
    }
    return note;
  }

  async function applyMaxQuantity() {
    const qtyInputs = document.querySelectorAll('input[is="quantity-input"][data-max-quantity]');
    if (!qtyInputs.length) return;

    const cart = await getCart();
    if (!cart) return;

    qtyInputs.forEach((input) => {
      const maxQty = parseInt(input.dataset.maxQuantity, 10);
      const form = input.form;
      if (!maxQty || !form) return;

      const idField = form.querySelector('input[name="id"]');
      const variantId = idField ? parseInt(idField.value, 10) : NaN;
      const inCart = cart.items
        .filter((item) => item.variant_id === variantId)
        .reduce((total, item) => total + item.quantity, 0);
      const remaining = Math.max(maxQty - inCart, 0);

      const submitButton = form.querySelector('button[type="submit"]');
      const note = ensureNote(input);

      if (remaining === 0) {
        if (submitButton && !submitButton.disabled) {
          submitButton.disabled = true;
          submitButton.dataset.maxQtyDisabled = 'true';
        }
        note.textContent = "You've reached the limit of " + maxQty + " for this item — it's in your cart.";
      } else {
        if (submitButton && submitButton.dataset.maxQtyDisabled) {
          submitButton.disabled = false;
          delete submitButton.dataset.maxQtyDisabled;
        }
        input.setAttribute('max', remaining);
        if (parseInt(input.value, 10) > remaining) {
          input.value = remaining;
        }
        note.textContent = inCart > 0
          ? 'Maximum ' + maxQty + ' of this item per order (' + inCart + ' already in your cart).'
          : 'Maximum ' + maxQty + ' of this item per order.';
      }
    });
  }

  document.addEventListener('cart:change', applyMaxQuantity);
  document.addEventListener('cart:refresh', applyMaxQuantity);
  document.addEventListener('variant:change', applyMaxQuantity);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMaxQuantity);
  } else {
    applyMaxQuantity();
  }
})();
